import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Col, Container, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import Tran_data_unlock_request from '../Tran_data_unlock_request';
import Tran_date_change_modal from './Tran_date_change_modal';
import CancelDialog from '../CancelDialog';

function Tran_pb() {
    const productRef = useRef();
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const [key, setKey] = useState("INFO");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [radioType, setRadioType] = useState("N");
    const [scrMode, setScrMode] = useState("");

    const [hdrSrno, setHdrSrno] = useState(0);
    const [pbList, setPBList] = useState([]);
    const [userRight, setUserRight] = useState([]);
    const [isdOptions, setIsdOptions] = useState([]);
    const [residentOptions, setResidentOptions] = useState([]);

    const [pbLocation, setPBLocation] = useState(null);
    const [pbLocationValue, setPBLocationValue] = useState(0);
    const [pbDealer, setPBDealer] = useState(null);
    const [pbFromDate, setPBFromDate] = useState(new Date());
    const [pbToDate, setPBToDate] = useState(new Date());
    const [pbNewDate, setPBNewDate] = useState(new Date());
    const [pbSrnoFrom, setPBSrnoFrom] = useState("");
    const [pbSrnoTo, setPBSrnoTo] = useState("");
    const [pbStateValue, setPBStateValue] = useState(0);
    const [pbStateName, setPBStateName] = useState("");
    const [pbStateType, setPBStateType] = useState(0);

    const [pOtherCharges, setPOtherCharges] = useState(0);
    const [pTotalAmount, setPTotalAmount] = useState(0);
    const [pCgst, setPCgst] = useState(0);
    const [pSgst, setPSgst] = useState(0);
    const [pIgst, setPIgst] = useState(0);
    const [pUgst, setPUgst] = useState(0);
    const [pForexTotal, setPForexTotal] = useState(0);
    const [pRoundOff, setPRoundOff] = useState(0);
    const [pTaxableVal, setPTaxableVal] = useState(0);

    const [pVtm, setPVtm] = useState(null);
    const [pProductList, setPProductList] = useState([]);
    const [pProduct, setPProduct] = useState("CN");
    const [pIsd, setPIsd] = useState(null);
    const [pDenomination, setPDenomination] = useState("");
    const [pQuantity, setPQuantity] = useState("");
    const [commission, setCommission] = useState("");
    const [pIssuer, setPIssuer] = useState(null);
    const [prPrefix, setPrPrefix] = useState("");
    const [prFrom, setPrFrom] = useState("");
    const [prTo, setPrTo] = useState("");
    const [pVtmCardNo, setPVtmCardNo] = useState("");
    const [pAgent, setPAgent] = useState(null);
    const [isCommission, setIsCommission] = useState("0");
    const [commType, setCommType] = useState("F");
    const [commValue, setCommValue] = useState("");
    const [pRate, setPRate] = useState("");
    const [counter, setCounter] = useState(0);
    const [productLineNo, setProductLineNo] = useState(0);
    const [pTravellerName, setPTravellerName] = useState("");
    const [pIdType, setPIdType] = useState("0");
    const [pIdNumber, setPIdNumber] = useState("");
    const [maxPRate, setMaxPRate] = useState(0);
    const [minPRate, setMinPRate] = useState(0);

    const [nDealer, setNDealer] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [nState, setNState] = useState({ value: 0, label: "Select" });
    const [nEmployeeCode, setNEmployeeCode] = useState("");
    const [nMode, setNMode] = useState("");
    const [disableOtherCharge, setDisableOtherCharge] = useState(true);
    const [randomString, setRandomString] = useState("");

    const [pdAccount, setPdAccount] = useState(null);
    const [pdPaymentType, setPdPaymentType] = useState("");
    const [pdAmount, setPdAmount] = useState("");
    const [pdAccountValue, setPdAccountValue] = useState("");
    const [pdChequeNum, setPdChequeNum] = useState("");
    const [paymentData, setPaymentData] = useState([]);
    const [pIsdId, setPIsdId] = useState("");
    const [ldgSrchType, setLdgSrchType] = useState("");
    const [paymentLineNo, setPaymentLineNo] = useState(0);

    const [chequeValue, setChequeValue] = useState(null);
    const [pdGroupValue, setPdGroupValue] = useState(0);

    const [hdrDate, setHdrDate] = useState(null);
    const [hdrLocation, setHdrLocation] = useState("");

    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);

    const [viewDate, setViewDate] = useState('');
    const currentDate = new Date();
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [usdRate, setUsdRate] = useState(0);
    const [disablePaymentAccount, setDisablePaymentAccount] = useState(false);

    const [showCommissionDetail, setShowCommissionDetail] = useState(false);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);

    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [dealerType, setDealerType] = useState("");
    const [nRemark1, setNRemark1] = useState("");
    const [nRemark2, setNRemark2] = useState("");
    const [compareData, setCompareData] = useState([]);
    const [showMinMaxRateModal, setShowMinMaxRateModal] = useState(false);
    const [minMaxRate, setMinMaxRate] = useState([]);
    const [hdrDateYmd, setHdrDateYmd] = useState("");
    const [nManualno, setNManualno] = useState(null);
    const [nExecutive, setNExecutive] = useState(null);
    const [openDateChangeModal, setOpenDateChangeModal] = useState(false);
    const [changeDateObj, setChangeDateObj] = useState({});
    const [dateChangeRight, setDateChangeRight] = useState();


    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");

    const [acRemark, setAcRemark] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [riskValue, setRiskValue] = useState("0");
    const [riskModalBoxText, setRiskModalBoxText] = useState("");
    const [cancelButtonView, setCancelButtonView] = useState(true);
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("")

    const [dealerName, setDealerName] = useState("");
    const [dealerPan, setDealerPan] = useState("");
    const [dealerAddress, setDealerAddress] = useState("");
    const [dealerGsitn, setDealerGstin] = useState("");

    const [agentName, setAgentName] = useState("");
    const [agentAddress, setAgentAddress] = useState("");
    const [agentPan, setAgentPan] = useState("");
    const [trandate, setTrandate] = useState(null);


    useEffect(() => {
        if (sessionStorage.getItem("activeBranch") == Common.HoCode) {
            sessionStorage.activeBranch = sessionStorage.getItem('activeBranchWithoutHo');
        }
        Common.getActiveBranch().then(response => {
            setPBLocation(response);
            response != null && handleLocationChange(response);
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_PB'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserCancelBillRight(resp);
            }
        });
        Common.callApi(Common.apiIsd, [sid, "ddlistjsonselect", 'CN'], result => {
            setIsdOptions(JSON.parse(result));
        });
        Common.callApi(Common.apiResidentialStatus, [sid, "listResidential"], result => {
            setResidentOptions(JSON.parse(result));
        });
        Common.callApi(Common.apiState, [sid, "getState", 1], result => {
            setStateOptions(JSON.parse(result));
        });
        Common.getDateChangeRight(sid, setDateChangeRight);//get right to change date

    }, []);

    const listPBdata = () => {

        var msg = [], i = 0;
        $(".loader").show();
        if (pbLocation === null || (radioType === 'S' && !pbSrnoFrom) || (radioType === 'S' && !pbSrnoTo) || (radioType === 'D' && !pbFromDate)
            || (radioType === 'D' && !pbToDate) || (radioType === 'I' && pbDealer === null) || (radioType === 'I' && !pbFromDate) || (radioType === 'I' && !pbToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pbLocation === null ? " Location." : '');
            msg[i++] = (radioType === 'S' && !pbSrnoFrom ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !pbSrnoTo ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !pbFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !pbToDate ? " To Date." : '');
            msg[i++] = (radioType === 'I' && pbDealer === null ? " Dealer." : '');
            msg[i++] = (radioType === 'I' && !pbFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'I' && !pbToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                radioType: radioType,
                pbLocation: pbLocationValue,
                pbDealer: pbDealer,
                pbNewDate: Common.dateYMD(pbNewDate),
                pbSrnoTo: pbSrnoTo,
                pbSrnoFrom: pbSrnoFrom,
                pbFromDate: Common.dateYMD(pbFromDate),
                pbToDate: Common.dateYMD(pbToDate)
            }
            Common.callApi(Common.apiTranPB, [sid, "pblist", JSON.stringify(obj)], result => {
                console.log(result);
                $(".loader").hide();
                setPBList(JSON.parse(result));
            });
        }
    }

    const handleLocationChange = (value) => {
        setPBLocation(value);
        var id = value.id;
        var location = id.split("^");
        setPBLocationValue(location[1]);
        setPBStateValue(location[3]);
        setPBStateType(location[4]);
        setPBStateName(location[5]);

        setHdrLocation(location[2]);
        setIsBranchDisableForAddNew(location[9]);
        sessionStorage.activeBranch = location[1];
    }

    const handleDealerChange = (value) => {
        setPBDealer(value);
    }

    const addNewForm = () => {
        var d = Common.dateYMD(pbNewDate);
        var ddmy = Common.dateDMY(pbNewDate);
        var ymd = Common.dateYMD(pbNewDate);
        // addNewFormResetFields(ddmy, ymd);
        var today = Common.dateYMD(new Date());
        if (pbLocation == null) {
            setMsgBox(true);
            setMsgText("Please select location");
        } else if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        } else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        } else {
            if (d == today) {
                addNewFormResetFields(ddmy, ymd);
            } else {
                const obj = {
                    billdate: d,
                    location: pbLocationValue,
                    type: "PB"
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (+resp.msg === 1) {
                        addNewFormResetFields(ddmy, ymd);
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = (ddmy, ymd) => {
        setHdrDate(ddmy);

        setScrMode("A");
        setKey("INFO");
        setHdrSrno(0);
        setNDealer(null);
        setNEmployeeCode("");
        if (pbStateValue * 1 > 0 && pbStateValue != null) setNState({ value: pbStateValue, label: pbStateName });
        else setNState({ value: 0, label: "Select" });

        setPProduct("CN");
        setPIsd(null);
        setPIsdId("");
        setPDenomination("");
        setPQuantity("");
        setPRate("");
        setPTravellerName("");
        setPIdNumber("");
        setPIdType("");
        setCommType("F");
        setCommValue("");
        setCommission("");
        setIsCommission("0");
        setPForexTotal(0);
        setPTotalAmount(0);
        setPCgst(0);
        setPIgst(0);
        setPUgst(0);
        setPSgst(0);
        setPRoundOff(0);
        setPOtherCharges(0);
        setPTaxableVal(0);

        setPProductList([]);
        setPaymentData([]);
        setProductLineNo(0);
        setPaymentLineNo(0);
        setPVtm(null);
        setNManualno(null);
        setNExecutive(null);
        setAcRemark("");
        setPAgent(null);


        setDealerName("");
        setDealerPan("");
        setDealerAddress("");
        setDealerGstin("");
        setTrandate(ymd);
    }

    const handleTabChange = (k) => {
        setKey(k);
        if (k === "PAYMENT") {
            const amt = paymentData.reduce((total, payment) => total + payment.tp_amount * 1, 0);
            setPdAmount(1 * pTotalAmount - amt);
        }
    }

    const handleNewDealerChange = (value) => {
        setNDealer(value);
        Common.callApi(Common.apiTranPP, [sid, "getDealerInfo", JSON.stringify(value)], result => {
            let resp = JSON.parse(result);
            setDealerName(resp.mvli_ledger_legal_name);
            setDealerPan(resp.mvli_pancard);
            setDealerAddress(resp.mvli_address);
            setDealerGstin(resp.mvli_gstin);

        });
        var dealer = value.id.split("^");
        setDealerType(dealer[6]);
        if (dealer[6] == "5") setPAgent(value);
        else setPAgent(null);

        if (pdPaymentType === "RC" || pdPaymentType === "PB")
            setPdAccount(value);
    }

    const otherChargeChange = (v) => {
        const obj = {
            tranType: "PB",
            type: "PURCHASE",
            uniquekey: Common.getRandomString(15),
            nState: nState.value,
            pOtherCharges: v === "" ? 0 : v.trim(),
            ppStateType: pbStateType,
            ppStateValue: pbStateValue
        }
        Common.validateDecValue(v, setPOtherCharges);
        if (Common.isPurelyNumeric(v.trim())) {
            calcInvoice(pProductList, obj);
        }
    }

    const roundOffHandler = (val) => {
        console.log(val)
        if (val === '') {
            setPRoundOff(0);
            setPTotalAmount((pForexTotal * 1) - pUgst - pSgst - pCgst - pIgst - pOtherCharges * 1);
            setPdAmount((pForexTotal * 1) - pUgst - pSgst - pCgst - pIgst - pOtherCharges * 1)
        } else
            if (val != '' && !Number.isNaN(val*1)) {//typeof (val * 1) === 'number'
                setPRoundOff(val * 1);
                setPTotalAmount((val * 1) + (pForexTotal * 1) - pUgst - pSgst - pCgst - pIgst - pOtherCharges * 1);
                setPdAmount((val * 1) + (pForexTotal * 1) - pUgst - pSgst - pCgst - pIgst - pOtherCharges * 1)
                // handleTabChange('PAYMENT');
            }
    }

    const handleAgentChange = (value) => {
        setPAgent(value);
        Common.callApi(Common.apiTranPP, [sid, "getAgentInfo", JSON.stringify(value)], result => {
            let resp = JSON.parse(result);
            setAgentName(resp.mvli_ledger_legal_name);
            setAgentPan(resp.mvli_pancard);
            setAgentAddress(resp.mvli_address);
        });
    }

    const handleProductChange = (v) => {
        setPProduct(v);
        setPIsd(null);
        setPVtm(null);
        setPDenomination("");
        setPRate("");
        setPrFrom("");
        setPVtmCardNo("");
        if (v === "VTM") {
            setPQuantity("1");
        }
        Common.callApi(Common.apiIsd, [sid, "ddlistjsonselect", v], result => {
            setIsdOptions(JSON.parse(result));
        });
    }

    const handleChangeIsd = (value) => {
        setPIsd(value);
        let a = value.id.split("^");
        setPIsdId(a[1]);
        if (dealerType !== "5") setPAgent(null);
        setCommType("F");
        setCommValue("");
        setCommission("");
        const obj = {
            isd: a[1],
            location: pbLocationValue,
            product: pProduct
        }
        Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPRate(resp.buyrate * 1);
            setMaxPRate(resp.maxbuyrate * 1);
            setMinPRate(resp.minbuyrate * 1);
            setUsdRate(resp.usdratebuy * 1);
        });
    }

    const handleDenoChange = (v) => {
        Common.validateDecValue(v, setPDenomination);
        setCommValue(calcCommission(commission, commType, pQuantity, v, pRate));
    }

    const handleQuantityChange = (v) => {
        Common.validateNumValue(v, setPQuantity);
        if (pProduct === "VTM" || pProduct === "TC") {
            setPrTo((v * 1 + prFrom * 1) - 1);
        }
        setCommValue(calcCommission(commission, commType, v, pDenomination, pRate));
    }

    const handleRateChange = (v) => {
        Common.validateDecValue(v, setPRate);
        if (pIsdId === "USD") {
            Common.validateDecValue(v, setUsdRate);
        }
        setCommValue(calcCommission(commission, commType, pQuantity, pDenomination, v));
    }

    const handleFromChange = (v) => {
        Common.validateNumValue(v, setPrFrom);
        setPrTo((v * 1 + pQuantity * 1) - 1);
        if (pProduct === "VTM") {
            setPrTo(v);
        }
    }

    const commissionTypeChange = (v) => {
        setCommType(v);
        setCommission("");
        setCommValue("");
    }

    const calcCommission = (value, type, quantity, deno, rate) => {
        var comm = 0;
        if (type === "P") {
            comm = (value * quantity * deno) / 100;
        } else if (type === "R") {
            comm = (quantity * deno * rate) * (value / 100);
        } else {
            comm = value;
        }
        if (comm > 0) return comm.toFixed(2);
        return comm;
    }

    const handleCommissionCalc = (v) => {
        Common.validateDecValue(v, setCommission);
        setCommValue(calcCommission(v * 1, commType, pQuantity, pDenomination, pRate));
    }

    const addProduct = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if ((pProduct === "CN" || pProduct === "TC") && pIsd == null || pDenomination === "" || pQuantity === "" || pRate === "" || pRate * 1 === 0) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd == null ? "Please select Isd." : '');
            msg[i++] = (pDenomination === '' ? "Please fill Denomination." : '');
            msg[i++] = (pQuantity == '' ? "Please fill Quantity." : '');
            msg[i++] = (pRate == '' || pRate * 1 === 0 ? "Please fill Rate." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if ((pProduct === "TC" || pProduct === "VTM") && (prFrom == "" || prTo == "" || pIssuer == null)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIssuer == null ? "Please select Issuer." : '');
            msg[i++] = (prFrom == '' ? "Please fill From." : '');
            msg[i++] = (prTo == '' ? "Please fill To." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if ((pProduct === "TC" || pProduct === "VTM") && (prTo * 1 - prFrom * 1 > 100)) {
            $(".loader").hide();
            setMsgText("'To' must be less than 100.");
            setMsgBox(true);
        } else if (+isCommission === 1 && (commType === "" || pAgent === null || commValue === "")) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pAgent == null ? "Agent." : '');
            msg[i++] = (commType == '' ? "Commission type." : '');
            msg[i++] = (commValue == '' ? "Commission value." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (maxPRate != 0 && minPRate != 0 && (pRate > maxPRate || pRate < minPRate)) {
            $(".loader").hide();
            msg[i++] = (pRate > maxPRate ? "Maximum rate is " + maxPRate : '');
            msg[i++] = (pRate < minPRate ? "Maximum rate is " + minPRate : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $(".loader").hide();
            var isd = pIsd.id.split("^");
            var agentgrp = 0;
            var agentaccnt = 0;
            var agentname = "";

            var issgrp = 0;
            var issaccnt = 0;
            if (pAgent !== null) {
                var agent = pAgent.id.split("^");
                agentgrp = agent[1];
                agentaccnt = agent[2];
                agentname = agent[5];
            }
            if (pIssuer !== null) {
                var issuer = pIssuer.id.split("^");
                issgrp = issuer[1];
                issaccnt = issuer[2];
            }
            var usdAmt = 0;
            if (usdRate != "" && usdRate != 0) {
                usdAmt = (pRate * pQuantity * pDenomination) / usdRate;
            }
            const obj = {
                tranType: "PB",
                type: "PURCHASE",
                uniquekey: Common.getRandomString(15),
                prd_line_no: 1 * productLineNo + 1,
                prd_location: pbLocationValue,
                prd_type: 'PB',
                prd_srno: hdrSrno,
                prd_isd: isd[1],
                prd_date: hdrSrno < 1 ? Common.dateYMD(pbNewDate) : hdrDateYmd,
                prd_product: pProduct,
                prd_deno: pDenomination,
                prd_qty: pQuantity,
                prd_rate: pRate,
                prd_amount: Math.round(pRate * pQuantity * pDenomination),
                prd_from: prFrom,
                prd_prefix: prPrefix,
                prd_to: prTo,
                prd_group: issgrp,
                prd_account: issaccnt,
                prd_agent_group: isCommission == "0" ? 0 : agentgrp,
                prd_agent_ledger: isCommission == "0" ? 0 : agentaccnt,
                prd_card_no: pVtmCardNo,
                isd_name: isd[2],
                randomString: randomString,
                prd_commission_type: commType,
                prd_commission_value: commValue == "" ? 0 : commValue,
                prd_commission: commission == "" ? 0 : commission,
                //nCorporate: nCorporate,
                nState: nState.value,
                pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
                ppStateType: pbStateType,
                ppStateValue: pbStateValue,
                scrMode: scrMode,
                prd_traveller_name: pTravellerName,
                prd_id_type: pIdType,
                prd_id_number: pIdNumber,
                prd_usd_rate: usdRate == "" ? 0 : Number(usdRate).toFixed(2),
                prd_usd_amount: Number(usdAmt).toFixed(2),
                prd_agent_name: isCommission == "0" ? "" : agentname,
                isCommission: isCommission,
                delny: "Y"
            }
            /*
            var productlist;
            const isdAlreadyExist = isIsdAlreadyExist(obj);
            if (isdAlreadyExist.isIsdExist) {
                productlist = Common.arrayChangeItem(pProductList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_qty', isdAlreadyExist.prdRow.prd_qty);
                productlist = Common.arrayChangeItem(pProductList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_amount', isdAlreadyExist.prdRow.prd_amount);
                productlist = Common.arrayChangeItem(pProductList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_usd_amount', isdAlreadyExist.prdRow.prd_usd_amount);
            } else {
                productlist = Common.arrayAddItem(pProductList, obj);
            }
            */
            var productlist = Common.arrayAddItem(pProductList, obj);
            if (productlist.length > 0) {
                setDisableOtherCharge(false);
            }
            const obj2 = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                // TLine: productLineNo + 1,
                TLoc: pbLocationValue,
                TType: 'PB',
                // TNum?
                Product: pProduct,
                ISD: isd[2],
                Deno: pDenomination,
                Quantity: pQuantity,
                Rate: pRate,
                Amount: pRate * pQuantity * pDenomination,
                // ...(pProduct === "ETC" ? {
                ProductFrom: prFrom,
                ProductTo: prTo,
                ProductPrefix: prPrefix,
                ProductGroup: issgrp,
                ProductAccout: issaccnt,
                // } : {}),
                CommsnType: commType,
                AgentGroupCode: agentgrp,
                AgentLedgerCode: agentaccnt,
                CommsnRate: commValue == "" ? 0 : commValue,
                CommsnAmount: commission == "" ? 0 : commission,

            }
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            setPProductList(productlist);
            setCounter(counter + 1);
            setProductLineNo(productLineNo + 1);
            setPIsd(null);
            setPIssuer(null);
            setPDenomination("");
            setPQuantity("");
            setPRate("");
            setPrPrefix("");
            setPrFrom("");
            setPrTo("");
            setPVtmCardNo("");
            setCommValue("");
            setCommission("");
            //setCommType();
            if (dealerType !== "5") setPAgent(null);
            setCommType("F");
            calcInvoice(productlist, obj);
            setAgentName("");
            setAgentPan("");
            setAgentAddress("");
        }
    }

    const isIsdAlreadyExist = (obj) => {
        var isIsdExist = false;
        var prdRow = {};
        for (var i = 0; i < pProductList.length; i++) {
            if (pProductList[i].prd_isd === obj.prd_isd && pProductList[i].prd_deno === obj.prd_deno && pProductList[i].prd_product === obj.prd_product) {
                prdRow.prd_line_no = pProductList[i].prd_line_no;
                prdRow.prd_qty = 1 * pProductList[i].prd_qty + obj.prd_qty * 1;
                prdRow.prd_amount = (prdRow.prd_qty * obj.prd_rate * obj.prd_deno).toFixed(2);
                prdRow.prd_usd_amount = (prdRow.prd_amount / usdRate).toFixed(2);
                isIsdExist = true;
                break;
            }
        }
        return { isIsdExist: isIsdExist, prdRow: prdRow };
    }

    const calcInvoice = (productlist, obj) => {
        Common.callApi(Common.apiCalcTaxable, [sid, "calcinvoice", JSON.stringify(productlist), JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPForexTotal(resp.fxamt);
            setPSgst(resp.sgst);
            setPTotalAmount(resp.totalamt);
            setPTaxableVal(resp.taxablevalue);
            setPRoundOff(resp.roundoff);
            setPCgst(resp.cgst);
            setPIgst(resp.igst);
            setPUgst(resp.ugst);
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * resp.totalamt - amt);
        });
    }

    const saveData = (issavedealer) => {
        $(".loader").show();
        var msg = [], i = 0;
        var totalinr = 0;
        for (var k = 0; k < paymentData.length; k++) {
            if (paymentData[k].tp_payment_type === "RC")
                totalinr -= paymentData[k].tp_amount * 1;
            else totalinr += paymentData[k].tp_amount * 1;
        }
        if (nDealer === null || nExecutive === null || (pTotalAmount > 0 && nState.value == 0)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (nExecutive === null ? "Executive." : '');
            msg[i++] = (nDealer === null ? "Dealer." : '');
            msg[i++] = ((pTotalAmount > 0 && nState.value == 0) ? "Place of Supply." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pTotalAmount != totalinr) {
            $(".loader").hide();
            setMsgText("Total amount of payment must be equal to calculated INR.");
            setMsgBox(true);
        } else if (acRemark === '' && issavedealer === true) {
            setShowModal(false);
            setMsgText('Please fill Remark!');
            setMsgBox(true);
            $(".loader").hide();
        } else if (scrMode === 'A' && pProductList.length < 1) {
            setMsgText("Productlist can't be empty.");
            setMsgBox(true);
            $(".loader").hide();
        } else if ((paymentData.filter(p => p?.tp_payment_type === 'PB').length >= 1) && (paymentData.length > 1)) {
            setMsgText("Only one payable allowed.");
            setMsgBox(true);
            $(".loader").hide();
        } else {
            setShowModal(false);
            const obj = {
                srno: hdrSrno,
                ppLocationValue: pbLocationValue,
                //nCorporate: nCorporate,
                nDealer: nDealer,
                //nCountry: nCountry.value,
                nState: nState.value,
                //nResident: nResident,
                nEmployeeCode: nEmployeeCode,
                pbNewDate: hdrSrno < 1 ? Common.dateYMD(pbNewDate) : hdrDateYmd,
                pForexTotal: pForexTotal,
                pSgst: pSgst,
                pIgst: pIgst,
                pUgst: pUgst,
                pCgst: pCgst,
                pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
                pRoundOff: pRoundOff,
                pTaxableVal: pTaxableVal === "" ? 0 : pTaxableVal,
                pTotalAmount: pTotalAmount,
                randomString: randomString,
                pProductList: pProductList,
                paymentData: paymentData,
                nRemark1: nRemark1,
                nRemark2: nRemark2,
                nManualno: nManualno,
                nExecutive: nExecutive,
                type: 'PB',
                issavedealer: issavedealer,
                riskValue: riskValue,
                riskRemark: acRemark,
            }

            const infoObject = Common.compareArrays(compareData, [obj]);

            if (+userRight.edit === 1 && scrMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'PB', pbLocationValue));
            }
            Common.callApi(Common.apiTranPB, [sid, "savedata", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
                let resp = JSON.parse(result);
                $(".loader").hide();
                if (resp.blacklistedYN?.isBlackListed && +resp.blacklistedYN.isBlackListed === 1) {
                    setMsgText(resp.blacklistedYN.name + " can't saved.Dealer is Red Flags." + resp.blacklistedYN.tsa_master + " " + resp.blacklistedYN.tsa_data_id + " " + "</br> Contact to compliance department.");
                    setMsgBox(true);
                    return;
                }
                if (resp.msg === "MSG0000") {
                    setScrMode("Q");
                    setKey("INFO");
                    //listPBdata();
                    let paramDate = Common.dateYMD(pbNewDate);
                    if (hdrSrno > 0) {
                        paramDate = hdrDateYmd;
                    }
                    fillViewForm(resp.srno, paramDate);
                    setTranAuditTrail([]);
                    expireUnlock();
                    if (resp.printhtml != "" && +Common.Billprint === 1) {
                        var newWindow = window.open();
                        newWindow.document.write(resp.printhtml);
                    }
                    setMsgBox(true);
                    setMsgText(Common.getMessage(resp.msg));
                } else if (resp.msg['riskvalue'] === '2') {
                    setShowModal(true);
                    setRiskModalBoxText(resp.msg['ledgername'] + " is medium risk. Please take the extra documentation.");
                    setRiskValue(resp.msg['riskvalue']);
                } else if (resp.msg['riskvalue'] === '3') {
                    setMsgBox(true);
                    setMsgText(resp.msg['ledgername'] + " is high risk.\nTransaction can not be saved.\n Please contact to compliance department.");
                } else {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
            });
        }
    }
    const expireUnlock = () => {
        if (scrMode == 'E' && unlockRequestType !== "SELF") {
            const obj = {
                srno: hdrSrno,
                type: 'PB',
                status: 'E',
                currentDate: Common.dateYMD(currentDate),
                pageright: 'TRAN_PB'
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            })

        }
    }

    const deleteProduct = (value) => {
        const itemToDelete = pProductList.find(item => item.uniquekey === value);

        if (itemToDelete) {
            const formattedItem = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: pbLocationValue,
                TType: 'PB',
                Product: itemToDelete.prd_product,
                ISD: itemToDelete.isd_name,
                Deno: itemToDelete.prd_deno,
                Quantity: itemToDelete.prd_qty,
                Rate: itemToDelete.prd_rate,
                Amount: itemToDelete.prd_amount,
                ProductFrom: itemToDelete.prd_from,
                ProductTo: itemToDelete.prd_to,
                ProductPrefix: itemToDelete.prd_prefix,
                ProductGroup: itemToDelete.prd_group,
                ProductAccout: itemToDelete.prd_account,
                AgentGroupCode: itemToDelete.prd_agent_group,
                AgentLedgerCode: itemToDelete.prd_agent_ledger,
                CommsnType: itemToDelete.prd_commission_type,
                CommsnRate: itemToDelete.prd_commission_value,
                CommsnAmnt: itemToDelete.prd_commission,
            }
            console.log(formattedItem);
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }
        }
        const obj = {
            tranType: "PB",
            type: "PURCHASE",
            uniquekey: Common.getRandomString(15),
            nState: nState.value,
            pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
            ppStateType: pbStateType,
            ppStateValue: pbStateValue
        }
        const productlist = Common.arrayRemoveItem(pProductList, "uniquekey", value);
        setPProductList(productlist);
        calcInvoice(productlist, obj);
        setCounter(counter - 1);
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    // const editData = () => {
    //     setScrMode("E");
    //     if (pProductList.length > 0) {
    //         setDisableOtherCharge(false);
    //     }
    // }

    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);
        console.log(dateA);
        console.log(dateB);
        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        console.log(differenceInMilliseconds);
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        console.log(differenceInDays);
        const obj = {
            srno: hdrSrno,
            type: 'PB',
            pageright: 'TRAN_PB',
            location: pbLocationValue
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
                if (pProductList.length > 0) {
                    setDisableOtherCharge(false);
                }

            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'PB', trannumber: hdrSrno, location: pbLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        });
    }
    const fillViewCompareObject = (resp) => {
        const obj2 = {
            nDealer: { id: resp.dealer_id, label: resp.dealer_label },
            nState: resp.state,
            nEmployeeCode: resp.emp_code,
            nRemark1: resp.remark1,
            nRemark2: resp.remark2,
        };
        setCompareData([obj2]);
    }

    const fillViewForm = (hdrsrno, date) => {
        setHdrSrno(hdrsrno);
        setKey('INFO');
        setRandomString("0");
        setViewDate(date);
        $(".loader").show();
        const obj = {
            srno: hdrsrno,
            ppLocationValue: pbLocationValue,
            type: "PB"
        }
        Common.callApi(Common.apiTranPB, [sid, "viewdata", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                $(".loader").hide();
                setScrMode("Q");
                fillViewCompareObject(resp);
                //setNServiceType(resp.service_type);
                //setNResident(resp.residential);
                //setNCorporate({ id: resp.corp_id, label: resp.corp_label });
                setNDealer({ id: resp.dealer_id, label: resp.dealer_label });
                setDealerName(resp.dealer_id.split("^")[11]);
                setDealerPan(resp.dealer_id.split("^")[12]);
                setDealerAddress(resp.dealer_id.split("^")[15]);
                setDealerGstin(resp.dealer_id.split("^")[9]);
                setNEmployeeCode(resp.emp_code);
                setNState({ value: resp.state, label: resp.statename });

                //setNDocument(resp.doc);
                setPForexTotal(resp.forextotal);
                setPCgst(resp.cgst);
                setPSgst(resp.sgst);
                setPIgst(resp.igst);
                setPUgst(resp.ugst);
                setPRoundOff(resp.round_off);
                setPTotalAmount(resp.total_inr);
                setPOtherCharges(resp.other_charge);
                setPTaxableVal(resp.taxablevalue);

                setPProductList(resp.productlist);
                setPaymentData(resp.paydetails);
                setProductLineNo(resp.maxlineno * 1);

                setHdrDate(resp.date);
                setHdrDateYmd(resp.dateymd);

                setHdrLocation(resp.locname);
                setHdrSrno(resp.srno);
                setNRemark1(resp.remark1);
                setNRemark2(resp.remark2);
                setCancelButtonView(+resp.hdr_cancel_billYN === 1 ? false : true);


                if (resp.manualid == null) setNManualno(null);
                else setNManualno({ id: resp.manualid, label: resp.manuallabel });

                if (resp.execid == null) setNExecutive(null);
                else setNExecutive({ id: resp.execid, label: resp.execabel });
                setTrandate(resp.ymdDate);
            }
        });
    }

    const handleAccountValue = (value) => {
        setPdAccount(value);
        var id = value.id.split("^");
        setPdGroupValue(id[1]);
        setPdAccountValue(id[2]);
    }

    const handlePaymentType = (v) => {
        setDisablePaymentAccount(false);
        setPdPaymentType(v);
        $(".loader").show();
        setPdAccount(null);
        setPdAccountValue(0);
        setPdChequeNum("");
        var ldgType = "";
        if (v === "") {
            $(".loader").hide();
            return;
        }
        if (v === "CH") {
            ldgType = "CASH";
        } else if (v === "BN" || v === "CQ") {
            ldgType = "BANK";
            setLdgSrchType("BANK");
            $(".loader").hide();
            return;
        } else if (v === "PB" || v === "RC") {
            ldgType = "WALKIN";
            setPdAccount(nDealer);
            setDisablePaymentAccount(true);
            $(".loader").hide();
            return;
        } else {// Advance
            setPdAccount(nDealer);
            $(".loader").hide();
            return;
        }
        setLdgSrchType(ldgType);
        Common.callApi(Common.apiLedger, [sid, "getledgerinfo", ldgType], result => {
            let resp = JSON.parse(result);
            setPdAccount({ id: resp.id, label: resp.label });
            $(".loader").hide();
        });
    }

    const addPayment = () => {
        var msg = [], i = 0;
        if (pTotalAmount < 1) {
            msg[i++] = (pTotalAmount < 1 ? "Total amount must be greater than 0." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pdPaymentType === "" || pdAccount === null || pdAmount < 1 || (pdPaymentType === 'CQ' && chequeValue === null) || (pdPaymentType === "BN" && pdChequeNum === "")) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pdAccount === null ? "Account." : '');
            msg[i++] = (pdPaymentType === "" ? "Payment Type." : '');
            msg[i++] = (pdAmount < 1 ? "Entered amount can't be 0." : '');
            if (pdPaymentType === 'CQ' && chequeValue === null) msg[i++] = (chequeValue === null ? "Select a Cheque." : '');
            if (pdPaymentType === "BN" && pdChequeNum === "") msg[i++] = (chequeValue === null ? "Refernece Number." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            // Check for duplicate reference number if payment type is BN
            if ((pdPaymentType === "BN") && pdChequeNum !== "") {
                const isDuplicateRef = paymentData.some(item =>
                    item.tp_payment_type === pdPaymentType &&
                    item.tp_cheque === pdChequeNum
                );

                if (isDuplicateRef) {
                    msg[i++] = `Reference number '${pdChequeNum}' is already used for '${pdPaymentType}.`;
                    setMsgText(Common.buildMessageFromArray(msg));
                    setMsgBox(true);
                    return;
                }
            }

            var grp = 0;
            var accnt = 0;
            var accntname = '';
            if (pdAccount !== null) {
                var a = pdAccount.id.split("^");
                grp = a[1];
                accnt = a[2];
                accntname = a[5];
            }

            let tcbb_srno = 0;
            let tcbb_line_no = 0;
            let tcbb_location = 0;
            let tcbb_from = 0;
            let tcbb_type = '';

            if (pdPaymentType === "CQ") {
                const ch = chequeValue.id.split("^");
                tcbb_srno = ch[1];
                tcbb_line_no = ch[2];
                tcbb_location = ch[3];
                tcbb_from = ch[4];
                tcbb_type = ch[5];
            }
            const obj = {
                uniquekey: Common.getRandomString(10),
                tp_line_no: paymentLineNo + 1,
                tp_location: pbLocationValue,
                tp_srno: hdrSrno,
                randomString: randomString,
                tp_payment_type: pdPaymentType,
                tp_account: accnt,
                tp_group: grp,
                mvli_ledger_name: accntname,
                tp_amount: pdAmount,
                tp_cheque: pdChequeNum,
                tp_type: "PB",
                chequeValue: chequeValue,
                delny: 'Y',
                tcbb_srno: tcbb_srno,
                tcbb_line_no: tcbb_line_no,
                tcbb_location: tcbb_location,
                tcbb_from: tcbb_from,
                tcbb_type: tcbb_type
            }
            // const existingItem = Common.isSamePaymentMethod(obj, paymentData);
            // if (existingItem) {
            //     existingItem.tp_amount = (existingItem.tp_amount * 1 || 0) + (obj.tp_amount * 1 || 0);
            //     existingItem.tp_cheque = pdChequeNum;
            // } else {
            const paymentdata = Common.arrayAddItem(paymentData, obj);
            setPaymentData(paymentdata);
            const obj2 = {
                TabType: "Payment",
                AType: "A",
                ALineNo: tranAuditTrail.length + 1,
                // TLine: paymentLineNo + 1,
                TLoc: pbLocationValue,
                TType: 'PB',
                PaymentType: pdPaymentType,
                PaymentLedgerCode: accnt,
                PaymentGroupCode: grp,
                PaymentAccountName: accntname,
                PaymentAmount: pdAmount,
                // ...(pdPaymentType == "BN" ? {
                ReferenceNo: pdChequeNum
                // } : {}),

            }
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            // }
            setPdPaymentType("");
            setPaymentLineNo(paymentLineNo + 1);
            setPdAmount("");
            setPdAccount(null);
            setChequeValue(null);
            setPdChequeNum("");
            const amt = paymentData.reduce((total, payment) => total + payment.tp_amount * 1, 0);
            setPdAmount(1 * pTotalAmount - amt);
            setCounter(counter + 1);
        }
    }

    const deletePayment = (value, delny) => {
        if (delny == "N") {
            setMsgBox(true);
            setMsgText("This cheque has already used.");
        } else {
            const itemToDelete = paymentData.find(item => item.uniquekey === value);

            if (itemToDelete) {
                const formattedItem = {
                    TabType: "Payment",
                    ALineNo: tranAuditTrail.length + 1,
                    AType: "D",
                    TLine: paymentLineNo + 1,
                    TLoc: pbLocationValue,
                    TType: 'PB',
                    PaymentType: itemToDelete.tp_payment_type,
                    PaymentGroupCode: itemToDelete.tp_group,
                    PaymentLedgerCode: itemToDelete.tp_account,
                    PaymentAccountName: itemToDelete.mvli_ledger_name,
                    PaymentAmount: itemToDelete.tp_amount,
                    ReferenceNo: itemToDelete.tp_cheque,
                };
                if (+userRight.edit === 1 && scrMode === 'E') {
                    setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
                }

            }
            setPaymentData(Common.arrayRemoveItem(paymentData, "uniquekey", value));
            const amt = paymentData.reduce((total, payment) => total + payment.tp_amount * 1, 0);
            setPdAmount(1 * pTotalAmount - amt);
        }
        setCounter(counter - 1);
    }

    const print = (printflag) => {
        $(".loader").show();
        const obj = {
            srno: hdrSrno,
            location: pbLocationValue,
            type: 'PB',
            printFlag: printflag,
        }
        Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
            $(".loader").hide();
            var newWindow = window.open();
            newWindow.document.write(result);
        });
    }


    const handleChequeValue = (value) => {
        setChequeValue(value);
        var id = value.id.split("^");
        setPdChequeNum(id[4]);
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: pbLocationValue, trannumber: hdrSrno, type: 'PB' });
    }

    const switchToPaymentTab = (e) => {
        if (e.key === 'Enter') setKey("PAYMENT");
        else if (e.key === "Tab") {
            e.preventDefault();
            productRef.current.focus();
        }
    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "PB", trannumber: hdrSrno, trancategory: "T", location: pbLocationValue });
    }

    const handleShowCommissionDetail = () => {
        setShowCommissionDetail(true);
    }

    const handleMinMaxRate = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (pIsd === null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd === null ? " Select ISD." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            setShowMinMaxRateModal(true);
            setPIsd(pIsd);
            let a = pIsd.id.split("^");
            setPIsdId(a[1]);//
            setPAgent(null);
            setCommType("F");
            setCommValue("");
            const obj = {
                isd: a[1],
                location: pbLocationValue,
                product: pProduct
            }
            Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                if (resp === "") {
                    alert("Select Individual First ");
                    // setMinMaxRate("");
                    $(".loader").hide();
                } else {
                    if (Array.isArray(resp)) {
                        setMinMaxRate(resp);
                    } else if (resp && typeof resp === 'object') {
                        setMinMaxRate([resp]);
                    }
                    $(".loader").hide();
                }
            });
        }
    }

    const handleManualNo = (value) => {
        setNManualno(value);
    }

    const handleExecutiveChange = (value) => {
        setNExecutive(value);
    }

    const changeDateModal = () => {
        var isOk = true;
        var msg = [], i = 0;
        if (pProductList.length > 0) {
            isOk = false;
            msg[i++] = "Please empty Product List.";
        }
        if (paymentData.length > 0) {
            isOk = false;
            msg[i++] = "Please empty Payment List.";
        }

        if (isOk) {
            setOpenDateChangeModal(true);
            setChangeDateObj(
                {
                    type: "PB",
                    srno: hdrSrno,
                    location: pbLocationValue,
                    right: "TRAN_PB",
                    billdate: hdrDate,
                    billdateymd: hdrDateYmd,
                    productList: pProductList,
                }
            );
        } else {
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }

    const handleCancelBill = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);
        const differenceInMilliseconds = dateB - dateA;
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        const obj = {
            srno: hdrSrno,
            type: 'PB',
            pageright: 'TRAN_PB',
            location: pbLocationValue
        }

        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'PB', trannumber: hdrSrno, location: pbLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        });


    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'PB',
            location: pbLocationValue,
            srno: hdrSrno,
            productList: pProductList,
            paymentList: paymentData,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                listPBdata();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }

    const handleSetIsCommission = (value) => {
        setIsCommission(value);
        if (dealerType !== "5") {
            setPAgent(null)
        };
        setCommType("F");
        setCommValue("");
        setCommission("");
    }

    const handleNextBill = () => {
        if (!hdrSrno || !pbLocationValue) {
            setMsgText("Bill Srno and Location required");
            setMsgBox(true);
        }

        // if hdrsrno and location available
        const obj = {
            srno: hdrSrno,
            location: pbLocationValue,
            type: "PB"
        };

        // Common.callApi(Common.apiCommom, 'Nextbillexists', JSON.stringify(obj), (result) => {
        Common.callApi(Common.apiCommom, [sid, "Nextbillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No next bill available.");
                setMsgBox(true);
            }
        })

    }
    const handlePrevBill = () => {
        if (!hdrSrno || !pbLocationValue) {
            setMsgText("Bill Srno and Location required");
            setMsgBox(true);
        }

        // if hdrsrno and location available
        const obj = {
            srno: hdrSrno,
            location: pbLocationValue,
            type: "PB"
        };

        // Common.callApi(Common.apiCommom, 'Nextbillexists', JSON.stringify(obj), (result) => {
        Common.callApi(Common.apiCommom, [sid, "Prebillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No Previous bill available.");
                setMsgBox(true);
            }
        })
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Purchase Bulk</h2>
                    </Col>
                </Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col className='col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "I"} onChange={() => setRadioType("I")} type='radio' label="Dealer" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={pbLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedWithoutHoPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLocationChange}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === "N" ?
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={pbNewDate}
                                                    onChange={(date) => setPBNewDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        : radioType === "S" ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={pbSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setPBSrnoFrom)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={pbSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setPBSrnoTo)} />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            : radioType === "D" || radioType === "I" || radioType === "C" ?
                                                <>
                                                    {
                                                        radioType === "I" ?
                                                            <Col className="col-md-6 col-12">
                                                                <Form.Group>
                                                                    <Form.Label>Dealer<span className="colorThemeRed">*</span></Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={pbDealer}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'DEALER', pbLocationValue)}
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={handleDealerChange}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Form.Group>
                                                            </Col>
                                                            : null
                                                    }
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={pbFromDate}
                                                                onChange={(date) => setPBFromDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={pbToDate}
                                                                onChange={(date) => setPBToDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                                : null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        +userRight.query === 1 && radioType !== "N" ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listPBdata()}>List</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        +userRight.add === 1 && radioType === "N" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Table responsive striped>
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Sr No</th>
                                            <th>Type</th>
                                            <th>Date</th>
                                            <th>Location</th>
                                            <th>Dealer</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            pbList.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <span onClick={() => fillViewForm(item.hdr_srno, item.new_date)} className='pointer colorThemeBlue'>
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    </td>
                                                    <td>{item.hdr_srno}</td>
                                                    <td>{item.hdr_type}</td>
                                                    <td>{item.hdr_date}</td>
                                                    <td>{item.entity_name}</td>
                                                    <td>{item.mvli_ledger_name}</td>
                                                    <td>{item.hdr_total_inr}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Row>
                        </>
                        :
                        <>
                            <Row style={{ display: "none" }}>
                                <Col>
                                    <p>{randomString}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (+userRight.edit === 1 && scrMode === 'Q' && cancelButtonView) ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData(false)}>Save</Button>
                                        </> : null
                                    }
                                    {
                                        (+userRight.query === 1 && scrMode === "Q") ? <>
                                            {
                                                +Common.Billprint === 1 &&
                                                <>
                                                    <Button variant='outline-success' size='sm' className='buttonStyle divHide' onClick={() => print("D")}>With Deno</Button>&nbsp;
                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => print("")}>Without Deno</Button>&nbsp;
                                                </>
                                            }
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                            {(+userRight.query === 1 && scrMode === 'Q') ? <>
                                                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                    btnActivityLog()}>Activity Log</Button>&nbsp;
                                            </> : null
                                            }
                                        </> : null
                                    }
                                    {
                                        scrMode === "Q" &&
                                        <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.delete === 1) &&
                                        <>
                                            &nbsp;
                                            {+dateChangeRight?.query === 1 &&
                                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userCancelBillRight.query === 1 && cancelButtonView) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.query === 1) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-primary    " className='buttonStyle' size="sm" onClick={() => handlePrevBill()}>Prev Bill</Button>
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.query === 1) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleNextBill()}>Next bill</Button>
                                        </>
                                    }

                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Location : <b>{hdrLocation} </b></span>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Date : <b>{hdrDate}</b></span>
                                </Col>
                                <Col className='ppCharges'>
                                    <span><b>Forex Total (INR): {pForexTotal}</b></span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span><b>Total Amount (INR): {pTotalAmount}</b></span>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                <Tab eventKey="INFO" title="Info">
                                    <Row>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Executive<span className="colorThemeRed">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nExecutive}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchExecutivePicklist}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleExecutiveChange}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Mode</Form.Label>
                                                <Form.Select disabled={scrMode === "Q"} value={nMode} onChange={e => setNMode(e.target.value)}>
                                                    <option value="B">In Branch</option>
                                                    <option value="D">Delivery</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-md-9 col-12">
                                            <Form.Group>
                                                <Form.Label style={{ display: "flex", alignItems: "center" }}>
                                                    <span>Dealer<span className="colorThemeRed">*</span></span>
                                                    <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={() => setNDealer(null)}><Badge bg="secondary">Reset</Badge></span>
                                                </Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nDealer}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchDealerTypePicklist(search, pbLocationValue, "1,2,3,4,5,8", trandate)}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleNewDealerChange}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Row>
                                            <Col className='col-md-3 col-3'>
                                                <Form.Label>Name : <b>{dealerName}</b></Form.Label>
                                            </Col>
                                            <Col className="col-md-2 col-2">
                                                <span>Pan : <b>{dealerPan} </b></span>
                                            </Col>
                                            <Col className="col-md-2 col-2">
                                                <span>Gstin : <b>{dealerGsitn}</b></span>
                                            </Col>
                                            <Col>
                                                <span>Address : <b>{dealerAddress}</b></span>
                                            </Col>
                                        </Row>
                                        {/* <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Country Visited</Form.Label>
                                                <Select isDisabled={scrMode === "Q"} options={countryOptions} value={nCountry} onChange={v => handleNewCountry(v)} />
                                            </Form.Group>
                                        </Col> 
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Residential Status<span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Select disabled={scrMode === "Q"} value={nResident} onChange={e => setNResident(e.target.value)}>
                                                    {
                                                        residentOptions.map((item, index) => (
                                                            <option value={item.mrs_srno} key={index}>{item.mrs_resident}</option>
                                                        ))
                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Corporate</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nCorporate}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE', ppLocationValue)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleCorporateChange}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>PAN/Form 60</Form.Label>
                                                <Form.Select disabled={scrMode === "Q"} value={nDocument} onChange={e => setNDocument(e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option value="F">Form 60</option>
                                                    <option value="P">PAN</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        */}
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Party Executive Name</Form.Label>
                                                <Form.Control disabled={scrMode === "Q"} placeholder='Employee Code' type='text' value={nEmployeeCode} onChange={e => Common.validateAlpNumValue(e.target.value, setNEmployeeCode)} maxLength={20} />
                                            </Form.Group>
                                        </Col>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Manual Number</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nManualno}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchManualTypePicklist(search, pbLocationValue, 'PB')} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleManualNo}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Place Of Supply</Form.Label>
                                                <Select isDisabled={true} options={stateOptions} value={nState} onChange={v => setNState(v)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 1</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 1' disabled={scrMode === "Q"} value={nRemark1} onChange={e => setNRemark1(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 2</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 2' disabled={scrMode === "Q"} value={nRemark2} onChange={e => setNRemark2(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("DETAILS")}>Details-&gt;</Button>
                                        </Col>
                                    </Row>
                                </Tab>
                                <Tab eventKey="DETAILS" title="Details">
                                    <Row>
                                        <Col>
                                            <h4>Product Info</h4>
                                        </Col>
                                    </Row>
                                    {
                                        scrMode === "Q" ? null
                                            :
                                            <>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Product<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Select value={pProduct} onChange={e => handleProductChange(e.target.value)} ref={productRef}>
                                                                <option value="CN">CN</option>
                                                                {/* <option value="TC">TC</option>
                                                                <option value="VTM">VTM</option> */}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    < Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>ISD<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pIsd}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, pProduct)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleChangeIsd}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        pProduct === "TC" || pProduct === "VTM" ?
                                                            <Col className="col-md-3 col-6">
                                                                <Form.Group>
                                                                    <Form.Label>Issuer<span className="colorThemeRed">*</span></Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={pIssuer}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', pbLocationValue)} // location = 1 , 2
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={value => setPIssuer(value)}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Form.Group>
                                                            </Col>
                                                            : null
                                                    }
                                                </Row>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>{pProduct === "VTM" ? "Value" : "Denomination"}
                                                                <span className="colorThemeRed">*</span>
                                                            </Form.Label>
                                                            <Form.Control disabled={pProduct === "VTM"} type='text' value={pDenomination} maxLength={5}
                                                                onChange={e => handleDenoChange(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col style={{ display: pProduct === "VTM" && "none" }} className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Quantity<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Control type='text' placeholder='Quantity' value={pQuantity} maxLength={9}
                                                                onChange={e => handleQuantityChange(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Rate<span className="colorThemeRed">*</span></Form.Label>
                                                            <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleMinMaxRate}><Badge bg="secondary">See Min/Max Rate</Badge></span>
                                                            <Form.Control type='text' placeholder='Rate' value={pRate} maxLength={Common.rateMaxLength}
                                                                onChange={e => handleRateChange(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {
                                                    pProduct === "TC" || pProduct === "VTM" ?
                                                        <Row>
                                                            <Col style={{ display: pProduct === "VTM" && "none" }} className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Prefix</Form.Label>
                                                                    <Form.Control placeholder='Prefix' type='text' maxLength={5} value={prPrefix} onChange={e => Common.validateAlpNumValue(e.target.value, setPrPrefix)} />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control disabled={pProduct === "VTM"} placeholder='From' type='text' maxLength={6} value={prFrom} onChange={e => handleFromChange(e.target.value)} />
                                                                </Form.Group>
                                                            </Col>
                                                            {
                                                                pProduct === "TC" ?
                                                                    <Col className='col-md-3 col-6'>
                                                                        <Form.Group>
                                                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                            <Form.Control disabled placeholder='To' type='text' maxLength={6} value={prTo} onChange={e => Common.validateNumValue(e.target.value, setPrTo)} />
                                                                        </Form.Group>
                                                                    </Col> :
                                                                    <Col className='col-md-3 col-6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Card No</Form.Label>
                                                                            <Form.Control disabled placeholder='Card No' type='text' value={pVtmCardNo} onChange={e => setPVtmCardNo(e.target.value)} />
                                                                        </Form.Group>
                                                                    </Col>
                                                            }
                                                        </Row>
                                                        : null
                                                }
                                                {/* <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Traveller Name</Form.Label>
                                                            <Form.Control placeholder='Traveller Name' type='text' maxLength={50} value={pTravellerName} onChange={e => Common.validateAlpValue(e.target.value, setPTravellerName)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>ID type</Form.Label>
                                                            <Form.Select value={pIdType} onChange={e => setPIdType(e.target.value)}>
                                                                <option value="0">Select</option>
                                                                <option value="1">Adhaar Card</option>
                                                                <option value="2">Passport</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>ID Number</Form.Label>
                                                            <Form.Control placeholder='ID Number' type='text' maxLength={30} value={pIdNumber} onChange={e => Common.validateAlpNumValue(e.target.value, setPIdNumber)} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row> */}
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Commission</Form.Label>
                                                            <Form.Select value={isCommission} onChange={e => handleSetIsCommission(e.target.value)}>
                                                                <option value="0">No</option>
                                                                <option value="1">Yes</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        +isCommission === 1 ?
                                                            <>
                                                                <Col className='col-md-12 col-12'>
                                                                    <Form.Group>
                                                                        <Form.Label>Agent<span className="colorThemeRed">*</span></Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={pAgent}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT', pbLocationValue)} // location = 1 , 2
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleAgentChange}
                                                                            isDisabled={dealerType == "5"}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Row>
                                                                    <Col className='col-md-3 col-3'>
                                                                        <Form.Label>Name : <b>{agentName}</b></Form.Label>
                                                                    </Col>
                                                                    <Col className="col-md-2 col-2">
                                                                        <span>Pan : <b>{agentPan} </b></span>
                                                                    </Col>
                                                                    <Col>
                                                                        <span>Address : <b>{agentAddress}</b></span>
                                                                    </Col>
                                                                </Row>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Select value={commType} onChange={e => commissionTypeChange(e.target.value)}
                                                                            disabled={true}
                                                                        >
                                                                            <option value="F">Flat</option>
                                                                            <option value="">Select</option>

                                                                            <option value="P">Paisa</option>
                                                                            <option value="R">Percentage</option>

                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>Commission<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Control type='text' maxLength={5} value={commission} onChange={e => handleCommissionCalc(e.target.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>Commission Value</Form.Label>
                                                                        <Form.Control disabled value={commValue} onChange={e => Common.validateDecValue(e.target.value, setCommValue)} />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                            : null
                                                    }
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addProduct()}>Add</Button>
                                                        &nbsp;
                                                        <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("PAYMENT")} onKeyDown={switchToPaymentTab}>Payment-&gt;</Button>
                                                    </Col>
                                                </Row>
                                            </>
                                    }
                                    <Row>
                                        <Col className="col-md-3 col-6">
                                            <Form.Check type='checkbox' checked={showCommissionDetail} onChange={e => setShowCommissionDetail(e.target.checked)} label='Commission Details' />
                                            {/* <Badge className='handCursor' bg="primary" onClick={handleShowCommissionDetail}>View Commission Details</Badge> */}
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Table responsive bordered striped>
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Product</th>
                                                    <th>Isd Code</th>
                                                    <th>Denomination</th>
                                                    <th>Quantity</th>
                                                    <th>Rate</th>
                                                    <th>Amount</th>
                                                    <th>USD Rate</th>
                                                    <th>USD Amount</th>
                                                    <th>Prefix</th>
                                                    <th>From</th>
                                                    <th>To</th>
                                                    <th>Traveller Name</th>
                                                    <th>ID Type</th>
                                                    <th>ID Number</th>
                                                    {
                                                        showCommissionDetail &&
                                                        <>
                                                            <th>Agent</th>
                                                            <th>Commission Type</th>
                                                            <th>Commission</th>
                                                            <th>Commission Value</th>
                                                        </>
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pProductList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    scrMode === "Q" || item.delny === "N" ? null :
                                                                        <span onClick={() => deleteProduct(item.uniquekey)} className='colorThemeBlue pointer'>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span>
                                                                }
                                                            </td>
                                                            <td>{item.prd_product}</td>
                                                            <td>{item.prd_isd}</td>
                                                            <td>{item.prd_deno}</td>
                                                            <td>{item.prd_qty}</td>
                                                            <td>{item.prd_rate}</td>
                                                            <td>{item.prd_amount}</td>
                                                            <td>{item.prd_usd_rate}</td>
                                                            <td>{item.prd_usd_amount}</td>
                                                            <td>{item.prd_prefix}</td>
                                                            <td>{item.prd_from}</td>
                                                            <td>{item.prd_to}</td>
                                                            <td>{item.prd_traveller_name}</td>
                                                            <td>{item.prd_id_type == 0 ? "" : item.prd_id_type}</td>
                                                            <td>{item.prd_id_number}</td>
                                                            {
                                                                showCommissionDetail &&
                                                                <>
                                                                    {
                                                                        item.prd_agent_group == "0" ?
                                                                            <td></td> :
                                                                            <td>{item.prd_agent_group + " " + item.prd_agent_ledger + " " + item.agent_name}</td>
                                                                    }
                                                                    <td>{item.prd_commission_type === "P" ? "Paisa"
                                                                        : item.prd_commission_type === "R" ? "Percentage"
                                                                            : item.prd_commission_type === "F" ? "Flat" : ""}</td>
                                                                    <td>{item.prd_commission * 1 > 0 ? item.prd_commission : ""}</td>
                                                                    <td>{item.prd_commission_value * 1 > 0 ? item.prd_commission_value : ""}</td>
                                                                </>
                                                            }
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Tab>
                                <Tab eventKey="PAYMENT" title="Payment">
                                    {/* <Row>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>Taxable Value: {pTaxableVal}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>SGST: {pSgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>IGST: {pIgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>CGST : {pCgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>UGST : {pUgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>Round Off: {pRoundOff}</Form.Label>
                                        </Col>
                                    </Row> */}
                                    <Row>
                                        <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                            <span>OtherCharges: &nbsp;</span>
                                            <span>
                                                <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                    maxLength={5}
                                                    value={pOtherCharges}
                                                    onChange={e => otherChargeChange(e.target.value)}
                                                    disabled={disableOtherCharge || scrMode === "Q"}
                                                />
                                            </span>
                                        </Col>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Round Off: &nbsp;</Form.Label>
                                                <Form.Control size='sm' placeholder='Round Off' type='number'
                                                    maxLength={10}
                                                    value={pRoundOff}
                                                    onChange={e => roundOffHandler(e.target.value)}
                                                    disabled={scrMode === "Q" && +userRight.add === 1}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col><h3>Payment Details</h3></Col>
                                    </Row>
                                    {
                                        scrMode === "Q" ? null
                                            :
                                            <>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Payment Type</Form.Label>
                                                            <Form.Select value={pdPaymentType} onChange={e => handlePaymentType(e.target.value)}
                                                            // onBlur={e => handlePaymentType(e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="BN">Bank</option>
                                                                <option value="CQ">Cheque</option>
                                                                <option value="PB">Payables</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Account<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pdAccount}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, ldgSrchType, pbLocationValue)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleAccountValue}
                                                                isDisabled={disablePaymentAccount}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        pdPaymentType !== "" ?
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Amount</Form.Label>
                                                                    <Form.Control placeholder='Amount' value={pdAmount} onChange={e => setPdAmount(e.target.value)} />
                                                                </Form.Group>
                                                            </Col> : null
                                                    }
                                                </Row>
                                                {
                                                    pdPaymentType === "BN" ?
                                                        <Row>
                                                            <Col className="col-md-12">
                                                                <Form.Group>
                                                                    <Form.Label>Reference No<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control placeholder='Reference No' maxLength={255} value={pdChequeNum} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdChequeNum)} />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        : pdPaymentType === "CQ" ?
                                                            <Row>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>Cheque No<span className="colorThemeRed">*</span></Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={chequeValue}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchChequeBookBankPicklist(search, pdGroupValue, pdAccountValue, pbLocationValue)}
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleChequeValue}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                            :
                                                            null
                                                }
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => addPayment()}>Add</Button>
                                                    </Col>
                                                </Row>
                                            </>
                                    }
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Table responsive striped bordered>
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Type</th>
                                                    <th>Group</th>
                                                    <th>Account</th>
                                                    <th>Name</th>
                                                    <th>Amount</th>
                                                    <th>Cheque/Ref no</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paymentData.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    scrMode !== "Q" && item.delny === "Y" ?
                                                                        <span className='colorThemeBlue pointer' onClick={() => deletePayment(item.uniquekey, item.delny)}>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span> : null
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    item.tp_payment_type === "BN"
                                                                        ? "Bank" : item.tp_payment_type === "CQ"
                                                                            ? "Cheque" : item.tp_payment_type === "CH"
                                                                                ? "Cash" : item.tp_payment_type === "RC"
                                                                                    ? "Receivables" : item.tp_payment_type === "PB"
                                                                                        ? "Payables" : item.tp_payment_type === "AP"
                                                                                            ? "Advance Paid" : item.tp_payment_type === "AR"
                                                                                                ? "Advance Received" : ""
                                                                }
                                                            </td>
                                                            <td>{item.tp_group}</td>
                                                            <td>{item.tp_account}</td>
                                                            <td>{item.mvli_ledger_name}</td>
                                                            <td>{item.tp_amount}</td>
                                                            <td>{item.tp_cheque}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Tab>
                            </Tabs>
                            <hr />
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (+userRight.edit === 1 && scrMode === 'Q' && cancelButtonView) ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData(false)}>Save</Button>
                                        </> : null
                                    }
                                    {
                                        (+userRight.query === 1 && scrMode === "Q") ? <>
                                            {
                                                +Common.Billprint === 1 &&
                                                <>
                                                    <Button variant='outline-success' size='sm' className='buttonStyle divHide' onClick={() => print("D")}>With Deno</Button>&nbsp;
                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => print("")}>Without Deno</Button>&nbsp;
                                                </>
                                            }
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                            {(+userRight.query === 1 && scrMode === 'Q') ? <>
                                                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                    btnActivityLog()}>Activity Log</Button>&nbsp;
                                            </> : null
                                            }
                                        </> : null
                                    }
                                    {
                                        scrMode === "Q" &&
                                        <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.delete === 1) &&
                                        <>
                                            &nbsp;
                                            {+dateChangeRight?.query === 1 &&
                                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                        </>
                }
            </Container >

            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Modal show={showMinMaxRateModal} size='xl' onHide={() => setShowMinMaxRateModal(false)} scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Row>
                            <Col>
                                <span>MIN/MAX RATE CARD</span>
                                <span>&nbsp;</span>
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Table striped responsive bordered>
                            <thead>
                                <tr>
                                    <th>ISD</th>
                                    <th> MINIMUM</th>
                                    <th>RATE</th>
                                    <th>MAXIMUM</th>
                                </tr>
                            </thead>
                            <tbody>
                                {minMaxRate.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.isd}</td>
                                        <td>{item.minbuyrate}</td>
                                        <td>{item.buyrate}</td>
                                        <td>{item.maxbuyrate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Row>
                </Modal.Body>
            </Modal>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />

            {/* <Tran_commission_view show={showCommissionDetail} onHide={() => setShowCommissionDetail(false)} productList={pProductList} /> */}

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                {msgTextYNBillDelete}
            </CancelDialog>
            <div>
                <Modal size='lg' show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Body>
                        <>
                            <h4>{riskModalBoxText}</h4>
                            <Form.Group>
                                <Form.Label>Action Taken<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Reason" maxLength={499}
                                    value={acRemark}
                                    onChange={(e) => Common.validateAlpValue(e.target.value, setAcRemark)}
                                    autoComplete="off"
                                    required />
                            </Form.Group>
                        </>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-success" onClick={() => saveData(true)}>
                            Save
                        </Button>{' '}
                        <Button variant="outline-success" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <Tran_date_change_modal openDateChangeModal={openDateChangeModal} setOpenDateChangeModal={setOpenDateChangeModal} changeDateObj={changeDateObj} setMsgBox={setMsgBox} setMsgText={setMsgText} />
        </>
    )
}

export default Tran_pb
